import React from "react";
import Header from "./Header";
import Hero from "./Hero";
import AudienceSplit from "./AudienceSplit";
import SocialProof from "./SocialProof";
import Footer from "./Footer";
import MeetTheFounder from "./MeetTheFounder";
import Stories from "./Stories";
import { colors } from "../config/site";

const Home = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: colors.cream }}>
      <Header />
      <Hero />
      <AudienceSplit />
      <SocialProof />
      <MeetTheFounder />
      <Stories />
      <Footer />
    </div>
  );
};

export default Home;
